import Big from 'big.js'
import { ZERO } from 'src/common/utils/big-utils'

export const calcRatio = (balance?: Big, totalBalance?: Big): Big | null => {
  if (!balance || !totalBalance) return null
  if (totalBalance.eq(0)) return ZERO
  return balance.div(totalBalance).mul(100)
}
